// Component to display the basic Job info as a card header
import JobBrokerCompanyName from '@/components/Scheduler/SchedulerMain/JobCard/JobInfo/JobBrokerCompanyName';
import JobOperatorsCount from '@/components/Scheduler/SchedulerMain/JobCard/JobInfo/JobOperatorsCount';
import JobProductLabel from '@/components/Scheduler/SchedulerMain/JobCard/JobInfo/JobProductLabel';
import JobStatusBadge from '@/components/Scheduler/SchedulerMain/JobCard/JobInfo/JobStatusBadge';
import ExternalLinkText from '@/components/common/ExternalLinkText';

import { getJobStartDatetime } from '@isd/lib/firebase/db/helpers';
import { JobDoc } from '@isd/lib/firebase/db/metaTypes';

import {
  reactAppJobDetailsRoute,
  reactAppJobEditRoute,
  reactAppUrl,
} from '@/env';
import { replaceParamsInRoute } from '@isd/lib/helpers/functions';

export default function JobInfo({ jobDoc }: { jobDoc: JobDoc }) {
  const jobData = jobDoc.data();

  const shouldOpenEditJobForm = jobDoc.get('overallStatus') === 'INCOMPLETE';

  const onClickJobTitle = () => {
    const jobId = jobDoc.id;
    const jobDetailsUrl = `${reactAppUrl}${replaceParamsInRoute(reactAppJobDetailsRoute, { jobId })}`;
    const editJobUrl = `${reactAppUrl}${replaceParamsInRoute(reactAppJobEditRoute, { jobId })}`;
    window.open(shouldOpenEditJobForm ? editJobUrl : jobDetailsUrl);
  };

  return (
    <div className="job-info grid h-full grid-cols-6">
      <div className="col-span-4">
        <JobStatusBadge jobDoc={jobDoc} />
        <ExternalLinkText
          text={jobData?.name || ''}
          textClassName="job-title h-12"
          onClick={onClickJobTitle}
          underlineOnHover
        />
      </div>
      <div className="job-start-time col-span-2 line-clamp-1 flex items-start justify-end text-right">
        {getJobStartDatetime(jobDoc).getTimeStr()}
      </div>
      <div className="col-span-6">
        <JobProductLabel jobDoc={jobDoc} />
      </div>
      <div className="col-span-4 mt-2">
        <div className="job-client-name font-bold" title="Job Client">
          {jobData?.clientName}
        </div>
        <JobBrokerCompanyName jobDoc={jobDoc} />
      </div>
      <JobOperatorsCount classNames="col-span-2" jobDoc={jobDoc} />
    </div>
  );
}
